<!-- <ng-container *ngIf="lookupdata.length > 0"> -->
<section class="mx-3">
    <ng-container>
        <div class="d-flex justify-content-between align-items-center">
            <div class="page_header">
                <h3 class="m-0 page_header_title">Subject List</h3>
            </div>
            <div *ngIf="actiondata.create" class="d-flex button-row">
                <div class="px-3">
                    <div class="bulk_button">
                        <!-- <input
                      #csvInput
                      hidden="true"
                      type="file"
                      onclick="this.value=null"
                      (change)="csvInputChange($event)"
                    /> -->
                        <button mat-raised-button class="bulk_button_add"
                            (click)="openUploadDialog('details', 'SUBJECTS_BULKUPLOAD_TEMPLATE')">
                            <img src="../../../assets/icons/fileupload.svg" class="me-2" alt="upload icon" />
                            <span>Bulk Upload</span>
                        </button>
                        <button mat-raised-button class="m-0 p-0 bulk_button_view" [matMenuTriggerFor]="menu"
                            color="primary">
                            <mat-icon class="m-0">expand_more</mat-icon>
                        </button>
                    </div>
                    <mat-menu #menu="matMenu" class="download_menu">
                        <button mat-menu-item (click)="
                        openUploadDialog('details', 'SUBJECTS_BULKUPLOAD_TEMPLATE')
                      " class="">
                            Upload Subjects Details
                        </button>
                        <button class="" mat-menu-item (click)="openUploadDialog('images', 'subjectImages')">
                            Upload Subjects Images
                        </button>
                    </mat-menu>
                </div>
                <div>
                    <button mat-raised-button color="primary" (click)="openAddSubjectDialog()"
                        class="px-5 add_button">Add</button>
                </div>
            </div>
        </div>
        <div class="position-relative">
            <!-- <div class="mt-2 table-container" *ngIf="actiondata?.list_view"> -->
            <div class="mt-2 table-container">
                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                    <!-- Checkbox Column -->
                    <!-- <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                  </mat-checkbox>
                </td>
              </ng-container> -->
                    <ng-container matColumnDef="subject_code">
                        <th mat-header-cell *matHeaderCellDef> Subject Code</th>
                        <td mat-cell *matCellDef="let element"> {{element.subject_code}} </td>
                    </ng-container>
                    <ng-container matColumnDef="subject_name">
                        <th mat-header-cell *matHeaderCellDef>Subject Name</th>
                        <td mat-cell *matCellDef="let element"> {{element.subject_name}} </td>
                    </ng-container>
                    <ng-container matColumnDef="medium_name">
                        <th mat-header-cell *matHeaderCellDef>Medium</th>
                        <td mat-cell *matCellDef="let element"> {{element?.medium_name}} </td>
                    </ng-container>
                    <ng-container matColumnDef="number_of_semisters">
                        <th mat-header-cell *matHeaderCellDef>Number Of Semisters</th>
                        <td mat-cell *matCellDef="let element"> {{element.number_of_semisters}} </td>
                    </ng-container>
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef> Description </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="description-container">
                                {{ element.description }}
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef> Status </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="status-container">
                                {{ element.status }}
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>Actions</th>
                        <td mat-cell *matCellDef="let row">
                            <!-- <button mat-raised-button  class="action_button" (click)="showsemesterdetails(row)">
                    View
                  </button> -->
                            <ng-container>
                                <button mat-icon-button class="action_button" [matMenuTriggerFor]="actionrequest"
                                    aria-label="menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #actionrequest="matMenu">
                                    <ng-container *ngIf="row.status == 'ACTIVE'">
                                        <button mat-menu-item class="action_button"
                                            (click)="actionrequestapi('INACTIVE', row.id)">
                                            <span>Disable</span>
                                        </button>
                                    </ng-container>
                                    <ng-container *ngIf="row.status == 'INACTIVE'">
                                        <button mat-menu-item class="action_button"
                                            (click)="actionrequestapi('ACTIVE', row.id)">
                                            <span>Enable</span>
                                        </button>
                                    </ng-container>
                                </mat-menu>
                            </ng-container>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)">
                    </tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4">No data</td>
                    </tr>
                </table>
            </div>
            <div class="mt-2" *ngIf="total_count > 5">
                <app-pagination [datafromparent]="total_count" (onDatePicked)="pagination($event)"></app-pagination>
            </div>
        </div>
    </ng-container>
</section>